import type { CountryCode, Env, RequestOptions } from "../types";

/** Country code → CHECK24 TLD suffix. */
export const COUNTRY_TLD_MAP: Readonly<Record<CountryCode, string>> = {
  at: "at",
  de: "de",
  es: "es",
};

export function getTldForCountry(country: CountryCode): string {
  return COUNTRY_TLD_MAP[country];
}

/**
 * Builds the Chronicle domain as `check24[-test].<tld>`.
 * Falls back to the platform domain if `country` is omitted.
 */
export function resolveChronicleDomain({
  country,
  env = "production",
}: Pick<RequestOptions, "country" | "env"> = {}): string {
  if (!country) {
    return Check24.platform.url.getDomain();
  }

  const prefix = env === "test" ? "check24-test" : "check24";
  return `${prefix}.${getTldForCountry(country)}`;
}

export type { CountryCode, Env };
